import React, { useEffect } from 'react'

import { useAPIGetPerencanaanRHKOptions } from 'api/kinerja/pengawas-sekolah/perencanaan'

import type {
  TPraktikKinerjaItem,
  TRHKOptionType,
} from 'types/kinerja-ps-pegawai'

type TUsePraktikKinerjaHooks = {
  praktikKinerjaData: TPraktikKinerjaItem[]
}
export const usePraktikKinerja = (
  onSuccess?: (data: TPraktikKinerjaItem[]) => void
): TUsePraktikKinerjaHooks => {
  const {
    data: perencanaanPraktikKinerjaResponse,
    isSuccess: isPerencanaanPraktikKinerjaSuccess,
  } = useAPIGetPerencanaanRHKOptions({
    type: 'praktik_kinerja' as TRHKOptionType,
  })

  const praktikKinerjaData = React.useMemo(() => {
    if (isPerencanaanPraktikKinerjaSuccess) {
      return perencanaanPraktikKinerjaResponse?.data ?? []
    }

    return []
  }, [
    isPerencanaanPraktikKinerjaSuccess,
    perencanaanPraktikKinerjaResponse?.data,
  ])

  useEffect(() => {
    if (isPerencanaanPraktikKinerjaSuccess) {
      onSuccess?.(praktikKinerjaData)
    }
  }, [isPerencanaanPraktikKinerjaSuccess, onSuccess, praktikKinerjaData])

  return {
    praktikKinerjaData,
  }
}
